<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="type === 'button'"
        color="error"
        :outlined="outlined"
        rounded
        style="min-width: 100%;"
        dark
        v-bind="attrs"
        v-on="on"
        @click="$emit('tooltip' + id)"
      >
        <v-icon class="mr-1">{{ icon }}</v-icon>
        {{ tooltipButtonText }}
      </v-btn>
      <v-btn
        v-if="type === 'icon'"
        color="error"
        fab
        outlined
        small
        dark
        v-bind="attrs"
        v-on="on"
        @click="$emit('tooltip' + id)"
      >
        <v-icon>{{ icon }}</v-icon>
      </v-btn>
    </template>
    <span>{{ tooltipText }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'Tooltip',

  props: {
    id: {
      type: String,
      required: true
    },
    tooltipButtonText: {
      type: String,
      required: true
    },
    tooltipText: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true,
      validator: value => ['button', 'icon'].includes(value)
    },
    icon: {
      type: String,
      required: true
    },
    outlined: {
      type: Boolean,
      default: false
    }
  }
}
</script>
